export const vw = (size: number, maxVw = 440, minSize = size * 0.8) => {
  const preferredValue = (size / 375) * 100;
  const maxValue = size * (maxVw / 375);

  return `clamp(${minSize.toFixed(2)}px, ${preferredValue.toFixed(2)}vw, ${maxValue.toFixed(2)}px)`;
};